<section class="panel panel--edit historico-editar" aria-labelledby="titulo-editar" data-testid="editar-historico">
    <h2 id="titulo-editar" class="panel__title">Editar registro del histórico</h2>
    <p class="panel__lead">
        {{ relacion.nombre }} {{ relacion.apellidos }} · {{ relacion.cargo }} · {{ relacion.nombreAsociacion }} · {{ relacion.anyoEjercicio }}
    </p>

    @if (!editable) {
        <div class="alert alert-info py-2" role="status" data-testid="no-editable">Solo se pueden editar relaciones vigentes o de ejercicios anteriores. Las bajas y los registros desactivados se conservan como están.</div>
    }
    @if (errorCarga) {
        <div class="alert alert-danger d-flex justify-content-between align-items-center py-2" role="alert" data-testid="error-carga">
            <span>{{ errorCarga }}</span>
            <button type="button" class="btn btn-outline-danger btn-sm" data-testid="reintentar-carga" (click)="cargar()">Reintentar</button>
        </div>
    }

    <fieldset class="fieldset-plain" [disabled]="!editable || guardando">
        <legend class="visually-hidden">Campos editables</legend>
        <div class="form-grid">
            <app-selector-busqueda inputId="editar-asociacion" etiqueta="Asociación" [opciones]="asociaciones" [cargando]="cargando" [valor]="asociacionId" [deshabilitado]="!editable || guardando" (elegido)="elegirAsociacion($event)"></app-selector-busqueda>
            <app-selector-busqueda inputId="editar-cargo" etiqueta="Cargo" [opciones]="cargos" [cargando]="cargando" [valor]="cargoId" [deshabilitado]="!editable || guardando" (elegido)="elegirCargo($event)"></app-selector-busqueda>
            <div>
                <label class="form-label" for="editar-ejercicio">Ejercicio</label>
                <select id="editar-ejercicio" class="form-select" data-testid="editar-ejercicio" [(ngModel)]="ejercicioId">
                    @for (e of ejercicios; track e.id) { <option [ngValue]="e.id">{{ e.anyo }}@if (e.vigente) { (vigente) }</option> }
                </select>
            </div>
            <div>
                <label class="form-label" for="editar-tipo">Tipo</label>
                <select id="editar-tipo" class="form-select" data-testid="editar-tipo" [(ngModel)]="tipoId" [disabled]="!tipoEditable || guardando">
                    <option [ngValue]="1">Altas</option>
                    <option [ngValue]="2">Cambios</option>
                </select>
            </div>
        </div>
    </fieldset>

    @if (hayCambios) {
        <div class="change-summary" data-testid="resumen-cambios-caja">
            <p class="change-summary__title"><i class="bi bi-pencil-square" aria-hidden="true"></i>Cambios pendientes de guardar</p>
            <ul data-testid="resumen-cambios">
                @for (linea of resumenCambios(); track linea) { <li>{{ linea }}</li> }
            </ul>
        </div>
    }
    @if (error) { <div class="alert alert-danger mt-3 mb-0" role="alert" data-testid="error">{{ error }}</div> }

    <div class="form-actions mt-3">
        <button type="button" class="btn btn-primary" data-testid="guardar" [disabled]="!puedeGuardar" (click)="guardar()">
            @if (guardando) { Guardando… } @else { <i class="bi bi-check-lg" aria-hidden="true"></i>Guardar cambios }
        </button>
        <button type="button" class="btn btn-outline-secondary" data-testid="cancelar" [disabled]="guardando" (click)="cancelar()">Cancelar</button>
    </div>
</section>
